import { useFeatureFlag } from "@/query/hooks/useFeatureFlags";

/**
 * Shared feature flag checks used by PreOrderHeader, PreOrderContent,
 * and other pre-order components.
 */
export function usePreOrderFeatureFlags() {
  const exportMode = useFeatureFlag("export_mode");
  return {
    hidePreOrderNumber: useFeatureFlag("hidePreOrderNumber") === true,
    showEmployeeAssignment:
      useFeatureFlag("assign_employee_pre_orders") !== false,
    isVivoMode: exportMode === "vivo",
    // No ERP export configured (empty / unset / "none", e.g. alarocca): the
    // confirm gesture is a plain local confirm, so its label must say
    // "Confirmer", not "Exporter vers l'ERP" (STK-1761). Mirrors the backend
    // `isErpExportEnabled` gate.
    // `!exportMode` also covers an empty-string flag value (the wire type is a
    // closed union without "", but the server sends raw JSON), matching the
    // backend `isErpExportEnabled` guard (mode !== "").
    isNoExport: !exportMode || exportMode === "none",
    pickLocationEnabled: useFeatureFlag("pickLocation") === true,
    pickRouteEnabled: useFeatureFlag("pickRoute") === true,
    pickDeliveryEnabled: useFeatureFlag("pickDelivery") === true,
    showWeightRecap: useFeatureFlag("showWeightRecap") !== false,
    showPricesRecap: useFeatureFlag("showPricesRecap") !== false,
    showProductDropdownMetadata:
      useFeatureFlag("showProductDropdownMetadata") !== false,
    allowCancelPreOrder: useFeatureFlag("allow_cancel_pre_order") !== false,
  };
}
